/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { ElectricalEquipmentCalibrationAttachmentDto } from '../models/electrical-equipment-calibration-attachment-dto';
import { ElectricalEquipmentCalibrationAttachmentDtoBaseResponse } from '../models/electrical-equipment-calibration-attachment-dto-base-response';
import { ElectricalEquipmentResponse } from '../models/electrical-equipment-response';
import { ElectricalEquipmentResponseDlmBaseResponse } from '../models/electrical-equipment-response-dlm-base-response';
import { ElectricalEquipmentResponseListDlmBaseResponse } from '../models/electrical-equipment-response-list-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class ElectricalEquipmentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiElectricalEquipmentElectricalEquipmentsGet
   */
  static readonly ApiElectricalEquipmentElectricalEquipmentsGetPath = '/api/ElectricalEquipment/electricalEquipments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentElectricalEquipmentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentElectricalEquipmentsGet$Plain$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<ElectricalEquipmentResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentElectricalEquipmentsGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentElectricalEquipmentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentElectricalEquipmentsGet$Plain(params?: {
    archived?: boolean;
  }): Observable<ElectricalEquipmentResponseListDlmBaseResponse> {

    return this.apiElectricalEquipmentElectricalEquipmentsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentResponseListDlmBaseResponse>) => r.body as ElectricalEquipmentResponseListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentElectricalEquipmentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentElectricalEquipmentsGet$Json$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<ElectricalEquipmentResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentElectricalEquipmentsGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentElectricalEquipmentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentElectricalEquipmentsGet$Json(params?: {
    archived?: boolean;
  }): Observable<ElectricalEquipmentResponseListDlmBaseResponse> {

    return this.apiElectricalEquipmentElectricalEquipmentsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentResponseListDlmBaseResponse>) => r.body as ElectricalEquipmentResponseListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiElectricalEquipmentNewElectricalEquipmentPost
   */
  static readonly ApiElectricalEquipmentNewElectricalEquipmentPostPath = '/api/ElectricalEquipment/new-electrical-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentNewElectricalEquipmentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentNewElectricalEquipmentPost$Plain$Response(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentNewElectricalEquipmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentNewElectricalEquipmentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentNewElectricalEquipmentPost$Plain(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<ElectricalEquipmentResponseDlmBaseResponse> {

    return this.apiElectricalEquipmentNewElectricalEquipmentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>) => r.body as ElectricalEquipmentResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentNewElectricalEquipmentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentNewElectricalEquipmentPost$Json$Response(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentNewElectricalEquipmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentNewElectricalEquipmentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentNewElectricalEquipmentPost$Json(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<ElectricalEquipmentResponseDlmBaseResponse> {

    return this.apiElectricalEquipmentNewElectricalEquipmentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>) => r.body as ElectricalEquipmentResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiElectricalEquipmentEditElectricalEquipmentPost
   */
  static readonly ApiElectricalEquipmentEditElectricalEquipmentPostPath = '/api/ElectricalEquipment/edit-electrical-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentEditElectricalEquipmentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentEditElectricalEquipmentPost$Plain$Response(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentEditElectricalEquipmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentEditElectricalEquipmentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentEditElectricalEquipmentPost$Plain(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<ElectricalEquipmentResponseDlmBaseResponse> {

    return this.apiElectricalEquipmentEditElectricalEquipmentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>) => r.body as ElectricalEquipmentResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentEditElectricalEquipmentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentEditElectricalEquipmentPost$Json$Response(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentEditElectricalEquipmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentEditElectricalEquipmentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentEditElectricalEquipmentPost$Json(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<ElectricalEquipmentResponseDlmBaseResponse> {

    return this.apiElectricalEquipmentEditElectricalEquipmentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>) => r.body as ElectricalEquipmentResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiElectricalEquipmentDeleteElectricalEquipmentPost
   */
  static readonly ApiElectricalEquipmentDeleteElectricalEquipmentPostPath = '/api/ElectricalEquipment/delete-electrical-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentDeleteElectricalEquipmentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentDeleteElectricalEquipmentPost$Plain$Response(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentDeleteElectricalEquipmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentDeleteElectricalEquipmentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentDeleteElectricalEquipmentPost$Plain(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<ElectricalEquipmentResponseDlmBaseResponse> {

    return this.apiElectricalEquipmentDeleteElectricalEquipmentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>) => r.body as ElectricalEquipmentResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentDeleteElectricalEquipmentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentDeleteElectricalEquipmentPost$Json$Response(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentDeleteElectricalEquipmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentDeleteElectricalEquipmentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiElectricalEquipmentDeleteElectricalEquipmentPost$Json(params?: {
    body?: ElectricalEquipmentResponse
  }): Observable<ElectricalEquipmentResponseDlmBaseResponse> {

    return this.apiElectricalEquipmentDeleteElectricalEquipmentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentResponseDlmBaseResponse>) => r.body as ElectricalEquipmentResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiElectricalEquipmentRestoreElectricalEquipmentPost
   */
  static readonly ApiElectricalEquipmentRestoreElectricalEquipmentPostPath = '/api/ElectricalEquipment/restore-electrical-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentRestoreElectricalEquipmentPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentRestoreElectricalEquipmentPost$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentRestoreElectricalEquipmentPostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentRestoreElectricalEquipmentPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentRestoreElectricalEquipmentPost$Plain(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiElectricalEquipmentRestoreElectricalEquipmentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentRestoreElectricalEquipmentPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentRestoreElectricalEquipmentPost$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentRestoreElectricalEquipmentPostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentRestoreElectricalEquipmentPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentRestoreElectricalEquipmentPost$Json(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiElectricalEquipmentRestoreElectricalEquipmentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet
   */
  static readonly ApiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGetPath = '/api/ElectricalEquipment/{electricalEquipmentId}/calibration-attachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Plain$Response(params: {
    electricalEquipmentId: number;
  }): Observable<StrictHttpResponse<Array<ElectricalEquipmentCalibrationAttachmentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGetPath, 'get');
    if (params) {
      rb.path('electricalEquipmentId', params.electricalEquipmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ElectricalEquipmentCalibrationAttachmentDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Plain(params: {
    electricalEquipmentId: number;
  }): Observable<Array<ElectricalEquipmentCalibrationAttachmentDto>> {

    return this.apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ElectricalEquipmentCalibrationAttachmentDto>>) => r.body as Array<ElectricalEquipmentCalibrationAttachmentDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Json$Response(params: {
    electricalEquipmentId: number;
  }): Observable<StrictHttpResponse<Array<ElectricalEquipmentCalibrationAttachmentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGetPath, 'get');
    if (params) {
      rb.path('electricalEquipmentId', params.electricalEquipmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ElectricalEquipmentCalibrationAttachmentDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Json(params: {
    electricalEquipmentId: number;
  }): Observable<Array<ElectricalEquipmentCalibrationAttachmentDto>> {

    return this.apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ElectricalEquipmentCalibrationAttachmentDto>>) => r.body as Array<ElectricalEquipmentCalibrationAttachmentDto>)
    );
  }

  /**
   * Path part for operation apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost
   */
  static readonly ApiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPostPath = '/api/ElectricalEquipment/{electricalEquipmentId}/calibration-attachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Plain$Response(params: {
    electricalEquipmentId: number;
    body?: { 'FormFile'?: Blob, 'CalibrationDate'?: string, 'Description'?: string }
  }): Observable<StrictHttpResponse<ElectricalEquipmentCalibrationAttachmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPostPath, 'post');
    if (params) {
      rb.path('electricalEquipmentId', params.electricalEquipmentId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentCalibrationAttachmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Plain(params: {
    electricalEquipmentId: number;
    body?: { 'FormFile'?: Blob, 'CalibrationDate'?: string, 'Description'?: string }
  }): Observable<ElectricalEquipmentCalibrationAttachmentDtoBaseResponse> {

    return this.apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentCalibrationAttachmentDtoBaseResponse>) => r.body as ElectricalEquipmentCalibrationAttachmentDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Json$Response(params: {
    electricalEquipmentId: number;
    body?: { 'FormFile'?: Blob, 'CalibrationDate'?: string, 'Description'?: string }
  }): Observable<StrictHttpResponse<ElectricalEquipmentCalibrationAttachmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPostPath, 'post');
    if (params) {
      rb.path('electricalEquipmentId', params.electricalEquipmentId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElectricalEquipmentCalibrationAttachmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Json(params: {
    electricalEquipmentId: number;
    body?: { 'FormFile'?: Blob, 'CalibrationDate'?: string, 'Description'?: string }
  }): Observable<ElectricalEquipmentCalibrationAttachmentDtoBaseResponse> {

    return this.apiElectricalEquipmentElectricalEquipmentIdCalibrationAttachmentsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ElectricalEquipmentCalibrationAttachmentDtoBaseResponse>) => r.body as ElectricalEquipmentCalibrationAttachmentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDownloadGet
   */
  static readonly ApiElectricalEquipmentCalibrationAttachmentsAttachmentIdDownloadGetPath = '/api/ElectricalEquipment/calibration-attachments/{attachmentId}/download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDownloadGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDownloadGet$Response(params: {
    attachmentId: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentCalibrationAttachmentsAttachmentIdDownloadGetPath, 'get');
    if (params) {
      rb.path('attachmentId', params.attachmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDownloadGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDownloadGet(params: {
    attachmentId: number;
  }): Observable<void> {

    return this.apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDownloadGet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete
   */
  static readonly ApiElectricalEquipmentCalibrationAttachmentsAttachmentIdDeletePath = '/api/ElectricalEquipment/calibration-attachments/{attachmentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Plain$Response(params: {
    attachmentId: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentCalibrationAttachmentsAttachmentIdDeletePath, 'delete');
    if (params) {
      rb.path('attachmentId', params.attachmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Plain(params: {
    attachmentId: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Json$Response(params: {
    attachmentId: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ElectricalEquipmentService.ApiElectricalEquipmentCalibrationAttachmentsAttachmentIdDeletePath, 'delete');
    if (params) {
      rb.path('attachmentId', params.attachmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Json(params: {
    attachmentId: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiElectricalEquipmentCalibrationAttachmentsAttachmentIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
